import { useCallback } from 'react';
import { formatTokenAmountDisplay, type TokenDetail, type TokenNumberFormatOptions } from '@/utils/tokenNumberUtils';

/**
 * hook to get a memoized token amount formatter.
 * formatter is pre-configured with token details.
 *
 * @param token token details (decimals, display_precision).
 * @returns A function `(value: bigint, options?: Partial<TokenNumberFormatOptions>) => string`
 *          that formats the given BigInt token amount. Returns '--.--' if token is not provided.
 */
export function useTokenFormatter(token?: TokenDetail) {
  return useCallback(
    (value: bigint, options?: Partial<TokenNumberFormatOptions>): string => {
      if (!token) {
        return '--.--';
      }
      if (value == null) {
        return '--.--';
      }
      return formatTokenAmountDisplay(value, token, options);
    },
    [token]
  );
}
